export default {
      id: "icon-info-light-usage",
      viewBox: "0 0 15 15",
      url: "/" + "images/icons.3.109.2.svg#icon-info-light-usage",
      toString: function () {
        return this.url;
      }
    }